import { LinkValue } from '@/lib/sanity/portable-text/marks/link.mark';

export const PAGE_WIDTH = {
    fullscreen: 'max-w-none',
    '1920': 'max-w-480',
    '1640': 'max-w-410',
    '1400': 'max-w-350',
    '1200': 'max-w-300',
    '992': 'max-w-248',
    '768': 'max-w-192',
    '576': 'max-w-144',
} satisfies Record<string, string>;

export const LINK_VARIANT_MAP: Record<NonNullable<LinkValue['variant']>, string> = {
    'pt-text-link': 'underline underline-offset-2 hover:text-primary',
    'pt-btn-link': 'link-btn link-primary link-lg',
    'pt-btn-primary': 'btn btn-primary btn-lg mt-2 lg:mt-0',
    'pt-btn-secondary': 'btn btn-outline btn-lg mt-2 lg:mt-0',
};
